import { ErrorMessage } from '@hookform/error-message'
import { CustomModal } from 'components'
import { UrlRegex, userType } from 'constant/const'
import React from 'react'
import { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useForm, useWatch } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
   addChannelAction,
   reset504Status,
   resetAddChannel,
   setDashboardStatus
} from 'store/action/AuthRedux'
import { setSelectChannelId, setUserType } from 'store/action/settingsReducer'
import { onResetVideoCount, setAllVideoDataAction, setPageNumberAction } from 'store/action/videoReducer'

function AddChannelModal({ show, onClose }) {
   const authData = useSelector((state) => state.user)
   const { addChannel, loading, addChannelData, addChannel504StatusError } = authData
   const settingData = useSelector((state) => state.settings)
   const { selectedUserTypes, selectedChannelID } = settingData
   const method = useForm({
      defaultValues: {
         channel_url: '',
         user_type: userType.OWNER
      }
   })
   const {
      handleSubmit,
      register,
      formState: { errors },
      reset,
      getValues,
      control
   } = method
   const dispatch = useDispatch()
   const navigate = useNavigate()

   const userTypeWatch = useWatch({ control, name: 'user_type' })

   useEffect(() => {
      if (addChannel && addChannelData) {
         dispatch(setUserType(userTypeWatch))
         // dispatch(setSelectChannelId(addChannelData?.channel_id))
         // navigate(`/dashboard?userType=${userTypeWatch}&channel_id=${addChannelData?.channel_id}`, {
         //    replace: true
         // })
         dispatch(onResetVideoCount())
         dispatch(setAllVideoDataAction([]))
         dispatch(setPageNumberAction(1))
         dispatch(resetAddChannel())
         onClose()
         reset()
      }
      return () => {}
   }, [addChannel])

   useEffect(() => {
      if (addChannel504StatusError) {
         dispatch(reset504Status())
         onClose()
         reset()
         window.location.reload()
      }
      return () => {}
   }, [addChannel504StatusError])

   const onSubmit = (data) => {
      dispatch(addChannelAction(data))
      dispatch(setDashboardStatus(true))
      navigate(`/dashboard/?userType=${selectedUserTypes}&channel_id=${selectedChannelID}`, {
         replace: true
      })
      // reset()
   }
   return (
      <div>
         <CustomModal
            show={show}
            title={'Add Channel'}
            loading={loading}
            // subTitle={'Minecraft But I regret Everything.. - Minecraft Hardcore #1'}
            closeModal={!loading && onClose}
            centered
            backdrop="static">
            <div>
               <div className="">
                  <div className="at-form">
                     <label className="at-text-dark">YouTube URL</label>
                     <input
                        type="url"
                        className={`form-control ${errors?.channel_url ? 'error' : ''}`}
                        placeholder="https://youtube.com/@channelname"
                        {...register('channel_url', {
                           required: { value: true, message: 'Please enter the channel link' },
                           pattern: {
                              value: UrlRegex,
                              message: 'Please enter valid url'
                           }
                        })}
                     />
                     <span className="error-text">
                        <ErrorMessage
                           errors={errors}
                           name="channel_url"
                           message={errors?.channel_url?.message}
                        />
                     </span>
                  </div>
                  <div className="at-form">
                     <label className="at-text-dark">Type</label>
                     <select className="form-select at-select-menu" {...register('user_type')}>
                        <option value={userType.OWNER}>{userType.OWNER}</option>
                        <option value={userType.INFLUENCER}>EXTERNAL</option>
                     </select>
                  </div>
                  <div className="mt-3 ">
                     {loading ? (
                        <div className="channel-btn w-100 text-center justify-content-center">
                           Adding channel, please wait…
                        </div>
                     ) : (
                        <div
                           className="channel-btn w-100 text-center justify-content-center"
                           onClick={handleSubmit(onSubmit)}>
                           Add Channel
                        </div>
                     )}
                  </div>
               </div>
            </div>
         </CustomModal>
      </div>
   )
}

export default AddChannelModal
